module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/shared/footer/footer.component.css
// module id = ./src/app/components/calculator/calculator-item/shared/footer/footer.component.css
// module chunks = main